import * as E from 'fp-ts/Either';
import { useEffect, useState } from 'react';
import { App, single } from '../api/apps';

export const useApp = (token?: string | null, shortCode?: string) => {
  const [app, setApp] = useState<App | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token || !shortCode) {
      return;
    }
    single(token, shortCode).then((result) =>
      E.isLeft(result)
        ? setError(
            `Error fetching app: ${
              result.left.helpMessage ?? result.left.message
            }`
          )
        : setApp(result.right)
    );
  }, [token, shortCode]);

  return { app, error };
};
